import {
	ChartNoAxesCombined,
	History,
	LayoutDashboard,
	Phone,
	Settings,
} from "lucide-react";
import { env } from "@/env/client";
import type { SidebarData } from "../types";

export const sidebarData: SidebarData = {
	navGroups: [
		{
			title: "General",
			items: [
				{
					title: "Dashboard",
					url: "/$tenantId",
					icon: LayoutDashboard,
				},
				{
					title: "Numbers",
					url: "/$tenantId/numbers",
					icon: Phone,
				},
				{
					title: "Call Logs",
					url: "/$tenantId/call-logs",
					icon: History,
				},
				...(env.VITE_CLI_PERFORMANCE_REPORT_ENABLED === "true"
					? [
							{
								title: "CLI Performance",
								url: "/$tenantId/cli-performance",
								icon: ChartNoAxesCombined,
							},
						]
					: []),
			],
		},
		{
			title: "Other",
			items: [
				{
					title: "Settings",
					icon: Settings,
					url: "/$tenantId/settings",
				},
			],
		},
	],
};
